import React from "react";
import Form, { useWatch } from "rc-field-form";
import styles from "./index.module.scss";
import { SimpleSwitch } from "../../../../../components/Fields/SimpleSwitch";
import { isTrue } from "../../../../../Utils/filter";

interface PushFieldProps {
    label: string;
    name: string;
    children?: React.ReactNode;
}

export function PushField({ label, name, children }: PushFieldProps) {
    const checked = useWatch(name);

    return (
        <div className={styles.root}>
            <div className={styles.master}>
                <div>{label}</div>
                <Form.Field name={name}>
                    <SimpleSwitch />
                </Form.Field>
            </div>

            {children && isTrue(checked) && (
                <div className={styles.sub}>{children}</div>
            )}
        </div>
    );
}
